import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

/**
 * @Deprecated: Use `@infodata-group/inf-commons-desktop` instead
 */
@Component({
  selector: 'infl-info',
  imports: [TranslatePipe],
  templateUrl: './info.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './info.component.scss',
})
export class InfoComponent {
  public text = input.required<string>();
  public icon = input<string | null>(null);
}
